import store from '@/store/index';
import authApiWrapper from '@/api/auth';
import loader from '@/components/utils/loader';

export default {
  name: 'Logout',
  components: {
    loader,
  },
  data() {
    return {
      hirefulAppDomain: process.env.VUE_APP_HIREFUL_APP_DOMAIN,
    };
  },
  computed: {
    isLoggedIn() {
      return store.getters['auth/getIsLoggedIn'];
    },
  },
  created() {
    this.logout();
  },
  methods: {
    async logout() {
      const vm = this;
      const queryString = vm.prepareQueryString();
      try {
        await vm.logoutFromCognito();
      } catch (error) {
        console.log('Error while logging out from cognito');
      }
      try {
        await authApiWrapper.methods.logout(vm, queryString);
        store.dispatch('reset');
        window.location = `https://login.${vm.hirefulAppDomain}/#/${queryString}`;
      } catch (error) {
        store.dispatch('reset');
        window.location = `https://login.${vm.hirefulAppDomain}/#/${queryString}`;
      }
    },
    prepareQueryString() {
      const vm = this;
      let queryString = '';
      if (vm.$route.query) {
        queryString = '?';
        Object.keys(vm.$route.query).forEach((k, i) => {
          queryString += `${k}=${vm.$route.query[k]}`;
          if (i < Object.keys(vm.$route.query).length - 1) {
            queryString += '&';
          }
        });
      }
      return queryString;
    },
  },
};
